import type { FaireProductEntity } from "../../entity_types/product";

export const p_bapztjm95c: FaireProductEntity = {
  token: "p_bapztjm95c",
  type: "product",
  name: "White Coconut Wax Candle with Crackling Wood Wick 12 oz",
  brandToken: "b_9vum56uxv5",
  brandName: "JAEMI GOODS",
  imageUrl:
    "https://cdn.faire.com/fastly/26b9a776158a6b4cafab614278d5b18c193a27cb8f6575e057191b5af89bc414.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6689dffd64618fff38deca782a5406034bf1a9dde851967ca4e2ec244b795ba.jpeg",
    "https://cdn.faire.com/fastly/e2bec63a57091d47f38c6c428f54d7faaa3bb352590277b0b0b108332e0ad8be.jpeg",
    "https://cdn.faire.com/fastly/854bdc13603c2f3642c02b04d711c7a4a45023a71d15c6afe69fad989090d7dc.jpeg",
    "https://cdn.faire.com/fastly/a7aaa3ee7eb63a0c31d85142595ec7f211ee14163137a6c350660be16593dbec.jpeg",
    "https://cdn.faire.com/fastly/564b71a48528231d5127b0b60f1e255cd9a512f1c3608fa016210ce77fdc481d.jpeg",
    "https://cdn.faire.com/fastly/f20f31fa2fb7e4fdfe1ae2a0b323c354afd486c2656caf8d82cc589541d2d95d.jpeg",
    "https://cdn.faire.com/fastly/0c45e9856b5927c0febcebd13b9d083a37a0d6d1d29c430aa16f967852eb0ae9.jpeg",
  ],
  priceDollars: 22.5,
  description:
    'Elevate your space with our White Candle — minimalist home decor, relaxation, and cozy ambiance in one beautiful coconut wax candle. This elegant white scented candle is perfect for gifting, self-care rituals, meditation, weddings, housewarmings, and everyday luxury.\n\nCrafted with care from a premium, premium natural coconut wax and a single-ply crackling wood strip wick, this candle delivers a long, even fragrance release that fills rooms with soothing atmosphere. The crisp white ceramic jar design complements modern, farmhouse, boho, and minimalist interior styles — making it a versatile accent for living rooms, bedrooms, bathrooms, offices, and small spaces.\n\nProduct Details:\n• Scent: Fresh Citrus\n• Wax: Premium natural coconut wax\n• Wick: Single-ply crackling wood strip\n• Size: 12 ounces\n• Dimensions: 3 ⅞" x 3 ¼"\n• Limited Edition Small Batch of 150 candles\n\nJAEMI GOODS is a “fun” inspired brand that brings playfulness to the home. We seek to incorporate fun, simple elements into everyday living with the purpose to bring smiles & joy to the world around us.\n\nJaemi (재미) comes from the Korean word for FUN - 재미.',
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:23.921Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
